import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setTimeContent } from "../../repository/slice";

function* getTimeContentWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/badge/admin/list", payload);
        if (isError) {

        } else {
            yield put(setTimeContent(data));
        }
    } catch (error) {
        console.error("getTimeContentWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getTimeContentWatcher() {
    yield takeLatest("@saga/GET_TIME_CONTENT", getTimeContentWorker);
};